import {append, assocPath, contains, lensPath, merge, view} from 'ramda';

import {getAction} from '../actions/constants';

const layout = (state = {}, action) => {
    if (action.type === getAction('SET_LAYOUT')) {
        return action.payload;
    } else if (
        contains(action.type, [
            'UNDO_PROP_CHANGE',
            'REDO_PROP_CHANGE',
            getAction('ON_PROP_CHANGE'),
        ])
    ) {
        const propPath = append('props', action.payload.itempath);
        const existingProps = view(lensPath(propPath), state);
        const mergedProps = merge(existingProps, action.payload.props);
        return assocPath(propPath, mergedProps, state);
    }

    return state;
};

export default layout;
